var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2107 39.769H12.7876V35.5309C19.5228 39.8505 28.3895 39.8505 35.2107 35.5314V39.769ZM12.7876 42.7843V41.7249H35.2107V42.7843H12.7876ZM5.88099 19.3951C5.88099 9.86077 13.9805 2.03725 24.0418 2.03725C34.1022 2.03725 42.1163 9.77922 42.1163 19.3953C42.1165 29.0117 33.9318 36.6724 23.9557 36.6724C13.9805 36.6719 5.88099 28.9304 5.88099 19.3951ZM44.248 19.3951C44.248 8.71983 35.1245 1.83573e-08 23.9557 1.83573e-08C12.7876 -0.000461995 3.66406 8.72005 3.66406 19.3953C3.66406 25.1816 6.30742 30.3973 10.5706 33.983V46.9404C10.5706 47.511 11.0813 48 11.6791 48C12.2759 47.9998 12.7876 47.511 12.7876 46.9406V44.8218H35.2107V46.8588C35.2107 47.4294 35.7223 47.9185 36.3191 47.9185C36.9162 47.9185 37.4276 47.4296 37.4276 46.8591V33.9014C41.5195 30.3968 44.248 25.1816 44.248 19.3951Z",
    fill: "url(#paint0_linear_486_1648)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9355 7.17091V8.63825C22.9355 9.20861 23.4471 9.69766 24.0439 9.69766C24.6407 9.69766 25.1524 9.20862 25.1524 8.63849V7.17091C31.376 7.65995 36.3212 12.3873 36.8319 18.3362L35.2982 18.3357C34.7014 18.3357 34.1895 18.8252 34.1895 19.3953C34.1895 19.9659 34.7011 20.455 35.2982 20.455H36.8321C36.3212 26.4036 31.3757 31.1307 25.1524 31.6197V30.1526C25.1524 29.5823 24.6407 29.0935 24.0439 29.0935C23.4471 29.0932 22.9355 29.5823 22.9355 30.1528V31.6195C16.7111 31.1302 11.7664 26.4041 11.2547 20.455H12.7896C13.3858 20.455 13.8981 19.9659 13.8981 19.3953C13.8981 18.825 13.3855 18.3362 12.7896 18.3362L11.255 18.3357C11.7664 12.387 16.7109 7.66041 22.9355 7.17091ZM22.9355 33.5754V34.1458C22.9355 34.7164 23.4471 35.2054 24.0439 35.2054C24.6407 35.205 25.1524 34.7164 25.1524 34.146V33.5754C32.5696 33.0864 38.452 27.4635 38.9636 20.3734H39.5604C40.1575 20.3734 40.6689 19.8844 40.6689 19.3142C40.6689 18.7434 40.1573 18.2546 39.5604 18.2546L38.9636 18.2542C38.452 11.1646 32.5696 5.54138 25.1524 5.0528V4.48198C25.1524 3.91116 24.6407 3.42282 24.0439 3.42282C23.4471 3.42259 22.9355 3.91163 22.9355 4.48222V5.05257C15.5173 5.54138 9.6349 11.1648 9.12326 18.2546L8.52644 18.2542C7.92961 18.2542 7.41797 18.7437 7.41797 19.3142C7.41797 19.8844 7.92937 20.3734 8.52644 20.3734H9.12326C9.6349 27.463 15.5173 33.0866 22.9355 33.5754Z",
    fill: "url(#paint1_linear_486_1648)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9554 13.2834C27.4514 13.2834 30.3504 16.0545 30.3504 19.3954C30.3504 22.7364 27.4512 25.5076 23.9554 25.5076C20.4604 25.5076 17.5612 22.7366 17.5612 19.3954C17.5614 16.0543 20.4604 13.2834 23.9554 13.2834ZM23.9554 27.5448C28.6451 27.5448 32.4818 23.8778 32.4818 19.3954C32.4821 14.9129 28.6451 11.2461 23.9554 11.2461C19.2667 11.2457 15.4297 14.9134 15.4297 19.3954C15.4297 23.8776 19.2667 27.5451 23.9554 27.5448Z",
    fill: "url(#paint2_linear_486_1648)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50299 2.03717C8.11513 2.03717 8.61145 2.51167 8.61145 3.09658C8.61145 3.68149 8.11513 4.15621 7.50299 4.15621C6.89108 4.15598 6.39453 3.68195 6.39453 3.09658C6.39453 2.5112 6.89085 2.03717 7.50299 2.03717Z",
    fill: "url(#paint3_linear_486_1648)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23736 9.12735C3.8495 9.12735 4.34583 9.60183 4.34583 10.1867C4.34583 10.7717 3.84926 11.2461 3.23736 11.2461C2.62522 11.2457 2.12891 10.7721 2.12891 10.1867C2.12891 9.60137 2.62522 9.12758 3.23736 9.12735Z",
    fill: "url(#paint4_linear_486_1648)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13118 29.5007C2.74332 29.5007 3.23964 29.9752 3.23964 30.5603C3.23964 31.145 2.74308 31.6197 2.13118 31.6197C1.51904 31.6195 1.02344 31.1454 1.02344 30.5603C1.02344 29.9752 1.51904 29.5007 2.13118 29.5007Z",
    fill: "url(#paint5_linear_486_1648)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7374 4.07446C44.3495 4.07446 44.8458 4.54895 44.8458 5.13386C44.8458 5.71923 44.3495 6.19349 43.7374 6.19349C43.1254 6.19349 42.6289 5.71923 42.6289 5.13386C42.6289 4.54872 43.1254 4.07469 43.7374 4.07446Z",
    fill: "url(#paint6_linear_486_1648)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8702 25.4259C46.4823 25.4259 46.9787 25.9004 46.9787 26.4855C46.9787 27.0707 46.4823 27.5449 45.8702 27.5449C45.2573 27.5447 44.7617 27.0707 44.7617 26.4855C44.7617 25.9004 45.2573 25.4261 45.8702 25.4259Z",
    fill: "url(#paint7_linear_486_1648)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6046 40.7468C42.2165 40.7468 42.713 41.2213 42.713 41.8064C42.713 42.3916 42.2165 42.8658 41.6046 42.8658C40.9924 42.8653 40.4961 42.3916 40.4961 41.8064C40.4961 41.2211 40.9924 40.747 41.6046 40.7468Z",
    fill: "url(#paint8_linear_486_1648)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50299 43.7621C8.11513 43.7621 8.61145 44.2366 8.61145 44.8217C8.61145 45.4066 8.11513 45.8811 7.50299 45.8811C6.89108 45.8811 6.39453 45.4068 6.39453 44.8217C6.39453 44.2366 6.89085 43.7623 7.50299 43.7621Z",
    fill: "url(#paint9_linear_486_1648)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9578 17.3581C25.1524 17.3581 26.0893 18.2546 26.0893 19.3954C26.0895 20.5365 25.1524 21.4328 23.9578 21.4328C22.7642 21.4324 21.827 20.5368 21.827 19.3954C21.827 18.2542 22.7642 17.3581 23.9578 17.3581ZM23.9578 23.4699C26.3454 23.4699 28.221 21.6775 28.221 19.3954C28.221 17.1137 26.3451 15.3209 23.9578 15.3209C21.5712 15.3204 19.6953 17.1137 19.6953 19.3954C19.6953 21.6772 21.6564 23.4701 23.9578 23.4699Z",
    fill: "url(#paint10_linear_486_1648)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23923 39.7689C2.6424 39.7689 2.13077 39.2801 2.13077 38.7095C2.13077 38.1387 2.6424 37.6501 3.23923 37.6501C3.83605 37.6501 4.34769 38.1392 4.34769 38.7095C4.2625 39.2799 3.75086 39.7689 3.23923 39.7689ZM3.23923 35.6942C1.44851 35.6942 0 37.0798 0 38.7911C0 40.5024 1.44851 41.888 3.23923 41.888C5.02971 41.8877 6.47918 40.5024 6.47918 38.7911C6.47918 37.0796 4.94451 35.6944 3.23923 35.6942Z",
    fill: "url(#paint11_linear_486_1648)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2477 35.6943C43.395 35.6943 42.6276 35.0424 42.6276 34.1461C42.6276 33.2495 43.3098 32.5976 44.2477 32.5976C45.1857 32.5972 45.8678 33.2495 45.8678 34.1461C45.8678 35.0424 45.1003 35.6945 44.2477 35.6943ZM44.2477 30.5602C42.2014 30.5602 40.4961 32.1901 40.4961 34.1461C40.4961 36.1018 42.2014 37.7317 44.2477 37.7317C46.2942 37.7313 47.9985 36.1018 47.9985 34.1461C47.9985 32.1901 46.294 30.5604 44.2477 30.5602Z",
    fill: "url(#paint12_linear_486_1648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_1648",
    x1: 23.956,
    y1: 0,
    x2: 23.956,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_1648",
    x1: 24.0434,
    y1: 3.42282,
    x2: 24.0434,
    y2: 35.2054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_1648",
    x1: 23.9558,
    y1: 11.2461,
    x2: 23.9558,
    y2: 27.5448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_1648",
    x1: 7.50299,
    y1: 2.03717,
    x2: 7.50299,
    y2: 4.15621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_1648",
    x1: 3.23737,
    y1: 9.12735,
    x2: 3.23737,
    y2: 11.2461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_1648",
    x1: 2.13154,
    y1: 29.5007,
    x2: 2.13154,
    y2: 31.6197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_1648",
    x1: 43.7374,
    y1: 4.07446,
    x2: 43.7374,
    y2: 6.19349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_1648",
    x1: 45.8702,
    y1: 25.4259,
    x2: 45.8702,
    y2: 27.5449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_1648",
    x1: 41.6045,
    y1: 40.7468,
    x2: 41.6045,
    y2: 42.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_1648",
    x1: 7.50299,
    y1: 43.7621,
    x2: 7.50299,
    y2: 45.8811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_486_1648",
    x1: 23.9582,
    y1: 15.3209,
    x2: 23.9582,
    y2: 23.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_486_1648",
    x1: 3.23959,
    y1: 35.6942,
    x2: 3.23959,
    y2: 41.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_486_1648",
    x1: 44.2473,
    y1: 30.5602,
    x2: 44.2473,
    y2: 37.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.df23e2f6a474240b8e8b32e302d0b908.svg";
export { ForwardRef as ReactComponent };